// extracted by mini-css-extract-plugin
module.exports = {"styles":"_2wT49f8BP-nN_ShtMkkIDy"};